import { dangerSvg, warningSvg, greenSvg } from '../icons/svgIcons';

export const calculateAspectRatio = (width, height) => width / height;

export const getDpiDisplay = (dpi) => {
  if (dpi <= 75) return { svg: dangerSvg, color: "#ff0000" };
  if (dpi <= 150) return { svg: warningSvg, color: "#d2cb04" };
  return { svg: greenSvg, color: "#0a9948" };
};

export function calculateAverageDPI(imageWidthPixels, imageHeightPixels, physicalWidthInches, physicalHeightInches) {
  const dpiWidth = imageWidthPixels / physicalWidthInches;
  const dpiHeight = imageHeightPixels / physicalHeightInches;
  return (dpiWidth + dpiHeight) / 2;
}

export function setColour(dpi, index, itemsFormik) {
  if (dpi <= 75) {
    itemsFormik.setFieldValue(`items[${index}].colorResolution`, "red");
  } else if (dpi <= 150) {
    itemsFormik.setFieldValue(`items[${index}].colorResolution`, "yellow");
  } else {
    itemsFormik.setFieldValue(`items[${index}].colorResolution`, "green");
  }
}

export const toPx = (value, unit) =>
  Number((unit === 'in' ? value * 300 : (value * 300) / 2.54).toFixed(2));

export const parseSizeParts = (sizeString, imageMeasureUnit) => {
  const parts = sizeString.split("X");
  const unit = imageMeasureUnit;
  let width, height;
  if (unit === "in") {
    width = parseFloat(parts[0].replace(/in/gi, "").trim()) * 300;
    height = parseFloat(parts[1].replace(/in/gi, "").trim()) * 300;
  } else {
    width = (parseFloat(parts[0].replace(/cm/gi, "").trim()) * 300) / 2.54;
    height = (parseFloat(parts[1].replace(/cm/gi, "").trim()) * 300) / 2.54;
  }
  return { width, height };
};

export const processMetadataResults = (metadataArray, files, imageMeasureUnit) => {
  const processedItems = [];
  metadataArray.forEach((metadata, idx) => {
    const file = files[idx];
    const aspectRatio = metadata.width / metadata.height;
    let newWidth, newHeight;
    if (imageMeasureUnit === "in") {
      newWidth = metadata.width / metadata.density;
      newHeight = metadata.height / metadata.density;
    } else {
      newWidth = (metadata.width / metadata.density) * 2.54;
      newHeight = (metadata.height / metadata.density) * 2.54;
    }
    let colorResolution;
    const dpi = metadata.density;
    if (dpi <= 75) colorResolution = "red";
    else if (dpi <= 150) colorResolution = "yellow";
    else colorResolution = "green";

    processedItems.push({
      image: file,
      imagePreview: URL.createObjectURL(file),
      width: newWidth.toFixed(2),
      height: newHeight.toFixed(2),
      originalWidth: newWidth.toFixed(2),
      originalHeight: newHeight.toFixed(2),
      aspectRatio,
      quantity: 1,
      density: dpi,
      newDensity: dpi,
      lockAspectRatio: true,
      colorResolution,
    });
  });
  return processedItems;
};
